var e = "11.1.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
